var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Loading } from 'element-ui';
import SalesReportService from '../../api/SalesReportService';
import TableHeaderToolTip from '../purchaseOrderForUpperSup/components/TableHeaderToolTip.vue';
import GlobalVue from "../../globalVue";
import Header from './components/DepotHeader.vue';
var SummaryDepotList = (function (_super) {
    __extends(SummaryDepotList, _super);
    function SummaryDepotList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.listData = [];
        _this.total = 0;
        _this.tableHeight = document.documentElement.clientHeight - 240;
        _this.showSummary = true;
        _this.order_money_count = 0;
        _this.order_amount_count = 0;
        _this.pending_order_money_count = 0;
        _this.cost_money_count = 0;
        _this.gross_profit_count = 0;
        _this.gross_margin = 0;
        _this.gross_margin_count = 0;
        _this.refund_count = 0;
        _this.refund_amount_count = 0;
        _this.refund_radio = 0;
        _this.refund_money_total = 0;
        _this.pending_refund_money_total = 0;
        _this.refund_amount = 0;
        _this.refund_money = 0;
        _this.order_loss_amount = 0;
        _this.order_loss_money = 0;
        _this.order_warehousing_amount = 0;
        _this.order_warehousing_money = 0;
        _this.after_amount_count = 0;
        _this.expand = [];
        _this.current_business_id = 0;
        return _this;
    }
    SummaryDepotList.prototype.created = function () {
        this.service = SalesReportService.getInstance();
    };
    SummaryDepotList.prototype.mounted = function () {
        var _this = this;
        setTimeout(function () {
            var height = _this.viewType == 1 || _this.viewType == 2 ? 250 : 230;
            _this.tableHeight = document.documentElement.clientHeight - height;
        }, 500);
    };
    SummaryDepotList.prototype.search = function (filter) {
        this.filter = filter;
        this.listFilter.business_keywords = filter.keywords;
        this.getList();
    };
    SummaryDepotList.prototype.expandChange = function (row, expandedRows) {
        var _this = this;
        if (expandedRows.length == 0) {
            return;
        }
        var params = {
            business_keywords: this.filter.business_keywords,
            supplier_goods_id: row.supplier_goods_id,
            business_id: row.business_id,
            viewType: this.viewType,
            from: this.filter.from,
            order_type: this.filter.order_type,
            time_type: this.filter.time_type,
            s_time: this.filter.s_time,
            e_time: this.filter.e_time,
        };
        var index = this.listData.indexOf(row);
        this.service.getListShopDetail(params).then(function (res) {
            if (res.data && res.data.success) {
                var tableData = Array.isArray(res.data.data) ? res.data.data : [];
                tableData.forEach(function (item, idx) {
                    GlobalVue.$set(_this.listData[index].tableData, idx, item);
                });
                GlobalVue.$set(_this.listData[index].tableData, "business_id", params.business_id);
                var data = res.data;
                _this.expand[params.business_id] = {
                    "expand_order_money_count": data.order_money_count || 0,
                    "expand_order_amount_count": data.order_amount_count || 0,
                    "expand_pending_order_money_count": data.pending_order_money_count || 0,
                    "expand_cost_money_count": data.cost_money_count || 0,
                    "expand_gross_profit_count": data.gross_profit_count || 0,
                    "expand_refund_amount_count": data.refund_amount_count || 0,
                    "expand_after_amount_count": data.after_amount_count || 0,
                };
                _this.current_business_id = params.business_id;
            }
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
        console.log(this.listData);
    };
    SummaryDepotList.prototype.getList = function (pager) {
        var _this = this;
        if (pager === void 0) { pager = { page: 1, start: 0, limit: 20 }; }
        var loadingInstance = Loading.service({ fullscreen: true });
        var serviceList = [
            {
                url: "getSummaryDepotDetail",
            },
            {
                url: "getGoodsCategoryDetail",
            },
            {
                url: "getGoodsDetail",
            }
        ];
        this.service[serviceList[this.viewType - 1].url](Object.assign(this.filter, pager, {
            depot_id: this.depot_id ? this.depot_id : this.filter.depot_id,
            from: this.listFilter.from,
            order_type: this.listFilter.order_type,
            time_type: this.listFilter.time_type,
            business_keywords: this.listFilter.business_keywords,
            s_time: this.listFilter.s_time,
            e_time: this.listFilter.e_time,
            goods_type_id: this.goods_type_id ? this.goods_type_id : this.filter.goods_type_id,
            supplier_goods_id: this.filter.supplier_goods_id ? this.filter.supplier_goods_id : null,
            group_id: this.filter.group_id ? this.filter.group_id : null,
            goods_format_id: serviceList[this.viewType - 1].url == 'getGoodsDetail' ? this.row.goods_format_id : null,
        }))
            .then(function (res) {
            loadingInstance.close();
            var DATA = res.data || { data: [], total: 0 };
            _this.listData = Array.isArray(DATA.data) ? DATA.data : [];
            _this.listData.forEach(function (item) {
                item['tableData'] = [];
            });
            _this.total = DATA.total;
            var data = DATA;
            _this.order_money_count = data.order_money_count || 0;
            _this.order_amount_count = data.order_amount_count || 0;
            _this.pending_order_money_count = data.pending_order_money_count || 0;
            _this.cost_money_count = data.cost_money_count || 0;
            _this.gross_profit_count = data.gross_profit_count || 0;
            _this.gross_margin = data.gross_margin || 0;
            _this.gross_margin_count = data.gross_margin_count || 0;
            _this.refund_count = data.refund_count || 0;
            _this.refund_amount_count = data.refund_amount_count || 0;
            _this.refund_money_total = data.refund_money_total || 0;
            _this.pending_refund_money_total = data.pending_refund_money_total || 0;
            _this.refund_money = data.refund_money || 0;
            _this.refund_amount = data.refund_amount || 0;
            _this.refund_radio = data.refund_radio || 0;
            _this.order_loss_amount = data.order_loss_amount || 0;
            _this.order_loss_money = data.order_loss_money || 0;
            _this.order_warehousing_amount = data.order_warehousing_amount || 0;
            _this.order_warehousing_money = data.order_warehousing_money || 0;
            _this.after_amount_count = data.after_amount_count || 0;
        })
            .catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    SummaryDepotList.prototype.getSummaries = function (param) {
        var sums;
        if (this.viewType == 1 || this.viewType == 2) {
            if (this.listFilter.order_type == 5) {
                sums = [
                    '合计',
                    '',
                    this.order_amount_count,
                    this.refund_amount_count,
                    this.after_amount_count,
                    this.cost_money_count,
                    this.order_money_count,
                    this.refund_amount_count,
                    this.refund_radio + '%',
                ];
            }
            else {
                sums = [
                    '合计',
                    '',
                    this.order_amount_count,
                    this.refund_amount_count,
                    this.after_amount_count,
                    this.cost_money_count,
                    this.order_money_count,
                    this.gross_profit_count,
                    this.gross_margin,
                ];
            }
        }
        else if (this.viewType == 3) {
            sums = [
                '合计',
                '',
                '',
                this.order_amount_count,
                this.refund_amount_count,
                this.after_amount_count,
                this.cost_money_count,
                this.order_money_count,
                this.gross_profit_count,
                this.pending_order_money_count,
            ];
        }
        return sums;
    };
    SummaryDepotList.prototype.getDetailSummaries = function (param) {
        var sums;
        if (param.data.length == 0 || this.expand[param.data.business_id] == undefined) {
            console.log(param.data.business_id);
            console.log(this.current_business_id);
            return [''];
        }
        var data = this.expand[param.data.business_id];
        return [
            '小计',
            data.expand_order_amount_count,
            data.expand_refund_amount_count,
            data.expand_after_amount_count,
            data.expand_cost_money_count,
            data.expand_order_money_count,
            data.expand_gross_profit_count,
            data.expand_pending_order_money_count,
        ];
    };
    SummaryDepotList.prototype.pageChange = function (pager) {
        this.getList(pager);
    };
    SummaryDepotList = __decorate([
        Component({
            components: {
                'list-header': Header,
                TableHeaderToolTip: TableHeaderToolTip,
            },
            methods: {
                renderHeader1: function (h, _a) {
                    var column = _a.column, $index = _a.$index;
                    return this.$createElement('TableHeaderToolTip', {
                        props: {
                            content: '毛利额 = 销售金额 -  销售成本',
                            placement: 'bottom',
                        },
                    }, '毛利额');
                },
                renderHeader2: function (h, _a) {
                    var column = _a.column, $index = _a.$index;
                    return this.$createElement('TableHeaderToolTip', {
                        props: {
                            content: '毛利率 = （销售金额 -  销售成本）/ 销售金额x100%',
                            placement: 'bottom',
                        },
                    }, '毛利率(%)');
                },
            },
        })
    ], SummaryDepotList);
    return SummaryDepotList;
}(Vue));
export default SummaryDepotList;
